import styled from 'styled-components'

const LanguageSwitcherStyle = styled.div`
	--langContPaddingV: var(--sp1x);
	--langItemPaddingH: var(--sp3x);
	--langItemPaddingV: var(--sp1-5x);
	--contDistance: var(--sp2x);
	--langContWidth: var(--sp10x);

	position: relative;
	display: inline-flex;
	text-transform: capitalize;
	line-height: 1;

	.lang-item-footer {
		margin-right: var(--sp4x);

		&.active {
			font-family: var(--helvetica);
			font-weight: bold;
			color: var(--primaryColor1);
			pointer-events: none;
		}

		&:last-child {
			margin-right: 0;
		}
	}

	.lang-item {
		text-align: center;
		color: var(--primaryColor1);
		font-family: var(--helvetica);
		font-size: var(--pXS);
	}

	/* .selected-lang {
		cursor: pointer;
	} */

	.languages-cont {
		display: flex;
		flex-direction: column;
		position: absolute;
		top: calc(100% + var(--contDistance));
		left: 50%;
		padding: var(--langContPaddingV) 0;
		border-radius: calc(var(--sp1x) * 0.5);
		opacity: 0;
		transform: translateX(-50%);
		box-shadow: 0px 3px 12px var(--secondaryColor2);
		pointer-events: none;
		width: var(--langContWidth);

		.lang-item {
			text-align: center;
			width: 100%;
			padding: var(--langItemPaddingV) var(--langItemPaddingH);
			background: transparent;
			transition: all var(--trTime);

			@media (hover: hover) {
				&:hover {
					background: var(--secondaryColor4);
				}
			}
		}

		&:before {
			content: '';
			position: absolute;
			bottom: 100%;
			left: 0;
			right: 0;
			height: var(--contDistance);
		}
	}

	@media not all and (hover: hover) {
		&.opened {
			.languages-cont {
				opacity: 1;
				pointer-events: all;
				transition: all var(--trTime);
			}
		}
	}
	@media (hover: hover) {
		&:hover {
			.languages-cont {
				opacity: 1;
				pointer-events: all;
				transition: all var(--trTime);
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--langItemPaddingH: var(--sp2x);
		--langContWidth: var(--sp7x);
	}
`

export default LanguageSwitcherStyle
